import React from 'react';
import banner1 from "../../assets/subbanner/pointing-worker-research-report-desk.jpg";
import banner from "../../assets/banner/aboutimage.jpeg";
import land3 from "../../assets/newservicesimge/oo1.jpeg";
import land4 from "../../assets/newservicesimge/oo2.jpeg";
import "./otherservice.css";



function Otherservice() {
    return (
        <>
            <section>
                <div className="image-all-banner">
                    <img src={banner1} alt="About Us" className="image-bg-all" />
                    <div className="overlay-all-page">
                        <h2 className="fade-in-text">Other Services</h2>
                    </div>
                </div>
            </section>

            <section>
                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Other Services</h5>
                                    <h3 id="#legal-dispute">Legal Assistance & Dispute Resolution:</h3>                                </div>
                                <div className='underline'></div>
                                <p>Property transactions and development often involve complex legal procedures. Our experienced legal team provides support in title verification, encumbrance checks, dispute settlements, and litigation management. We work to resolve conflicts amicably and swiftly while safeguarding your interests, ensuring all property dealings are secure, transparent, and free from future complications.</p>
                            </div>
                            <h1> </h1>
                        </div>


                        <div className='col-md-6'>
                            <div className='image-container-right'>
                                <img src={land4} className='image-container-inside' />
                            </div>
                        </div>
                    </div>

                </div>

                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-md-6 order-2  order-md-1'>
                            <div className='image-container-right'>
                                <img src={land3} className='image-container-inside' />
                            </div>

                        </div>


                        <div className='col-md-6 order-21  order-md-2'>
                            <div className="section-title clearfix ">
                                <div class="title-header">
                                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>Other Services</h5>
                                    <h3 id="government-approvals">Government Approvals & Sanction Assistance:</h3>                                </div>
                                <div className='underline'></div>
                                <p>Navigating government departments for approvals and sanctions can be a time-consuming process. We act as a liaison between you and the relevant authorities to obtain all required permissions—be it layout approvals, building permits, environmental clearances, or utility connections. Our familiarity with local bylaws and government protocols ensures a smooth, compliant process from start to finish.</p>
                            </div>

                        </div>
                    </div>

                </div>



            </section>

        </>
    )
}

export default Otherservice;
